import React, { useRef, useEffect } from 'react';

const AutoGrowingTextarea = ({ value, onChange, style, ...props }) => {
    const textareaRef = useRef(null);

    const adjustHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    useEffect(() => {
        adjustHeight();
    }, [value]);

    return (
        <textarea
            ref={textareaRef}
            value={value}
            onChange={(e) => {
                adjustHeight();
                if (onChange) onChange(e);
            }}
            style={{
                ...style,
                resize: 'none',
                overflow: 'hidden',
            }}
            {...props}
        />
    );
};

export default AutoGrowingTextarea;
